import { isTenantThemeDataAvailable } from 'owa-theme/lib/selectors/isTenantThemeDataAvailable';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function getShouldShowOfficeTheme() {
    // try/catch is workaround for issue in storybook where an add-in calls getAllThemeIds() before
    // the features are initialized
    try {
        return isFeatureEnabled('fwk-cobranding') && isTenantThemeDataAvailable();
    } catch {
        return false;
    }
}
